module.exports = __webpack_public_path__ + "static/media/Case-Stadies.d1606c42.jpg";